import { useSelector } from 'react-redux';

// Components
// Components
import Main from 'components/common/Layout/Main';
import ContactUs from 'components/templates/contact';

// Libs
import Translation from 'libs/Translation';

const Contact = () => {
	const {webConfig} = useSelector(state => state.core);

    const title = Translation.t('title.contact');
	const description = Translation.t('text.contact-vclinic-support');

	const breadCrumb = {
		itemListElements: [
			{
				position: 1,
				name: Translation.t('title.default'),
				item: 'https://vclinic.io',
			},
			{
				position: 2,
				name: Translation.t('title.contact'),
				item: `https://vclinic.io/contact`,
			},
		],
	};

	const seo = {
		title: `${title} | ${Translation.t('title.default')}`,
        description: description,
		h1Title: title,
		additionalMetaTags: [],
	};

    return (
        <Main breadCrumb={breadCrumb} seo={seo}>
            <ContactUs webConfig={webConfig}/>
        </Main>
    )
}
export default Contact;